import { render, staticRenderFns } from "./ContentTabBody.vue?vue&type=template&id=ecd7b6e8&scoped=true&"
import script from "./ContentTabBody.vue?vue&type=script&lang=js&"
export * from "./ContentTabBody.vue?vue&type=script&lang=js&"
import style0 from "./ContentTabBody.vue?vue&type=style&index=0&id=ecd7b6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd7b6e8",
  null
  
)

export default component.exports